import Model, { attr, belongsTo } from '@ember-data/model';

export default class PermisoModel extends Model {
  @attr('string') codigo;

  @attr('string') nombre;

  @attr('string') descripcion;

  @attr('boolean', { defaultValue: true }) activo;

  @attr('number') orden;

  @attr('boolean') soloSuperAdmin;

  @belongsTo('permiso-grupo', { async: false, inverse: null }) grupo;

  get activoFormatted() {
    return this.activo ? 'Sí' : 'No';
  }
}
